import Vue from 'vue'
import moment from 'moment'

export default ({ store }) => {

  Vue.prototype._ = function (key) {
    const state = store.state
    if (state && state._ && state._[state.locale] && state._[state.locale][key]) {
      return state._[state.locale][key]
    }
    return key
  }

  Vue.prototype.moment = moment

  Vue.prototype.convertToHoursAndMinutes = function (s) {
    let re = new RegExp(' ' + this._('min') + '$')
    if (!s.match(re)) {
      return s
    }
    let minuteArr = s.match(/^[0-9]+/)
    let minutes = minuteArr[0]
    let hours = Math.floor(minutes / 60)
    let remainder = minutes % 60
    return (hours > 0 ? hours + ' ' + this._('h') : '') + (hours > 0 && remainder > 0 ? ' ' : '') + (remainder > 0 ? remainder + ' ' + this._('min') : '')
  }

}